import { render, staticRenderFns } from "./NoteCenter.vue?vue&type=template&id=6bc03fab&scoped=true"
import script from "./NoteCenter.vue?vue&type=script&lang=js"
export * from "./NoteCenter.vue?vue&type=script&lang=js"
import style0 from "./NoteCenter.vue?vue&type=style&index=0&id=6bc03fab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc03fab",
  null
  
)

export default component.exports